import actions from '@/store/users/actions';

const usersModule = {
  state: () => ({
    users: [],
    usersForPromoCode: [],
    total: null,
    pmUsers: [],
    totalPmUsers: null,
    isNewUser: false,
    isUpdated: false,
    isLoading: false,
    currentUser: {},
    userShippingInfo: {},
    userBillingInfo: {},
  }),
  getters: {},
  mutations: {
    GET_USERS_START(state) {
      state.isLoading = true;
    },
    GET_USERS_SUCCESS(state, data) {
      state.users = data.data;
      state.total = data.total;
      state.isLoading = false;
    },
    GET_USERS_FAILURE(state) {
      state.isLoading = false;
    },
    GET_USER_BILLING_SUCCESS(state, data) {
      state.userBillingInfo = data;
    },
    GET_USER_SHIPPING_SUCCESS(state, data) {
      state.userShippingInfo = data;
    },
    GET_FIND_USER_FOR_PROMO_CODE_SUCCESS(state, data) {
      state.usersForPromoCode = data;
    },
    GET_PM_USERS_START(state) {
      state.isLoading = true;
    },
    GET_PM_USERS_SUCCESS(state, data) {
      state.pmUsers = data.data;
      state.totalPmUsers = data.total;
      state.isLoading = false;
    },
    GET_PM_USERS_FAILURE(state) {
      state.isLoading = false;
    },
    GET_USER_BY_ID_SUCCESS(state, data) {
      state.currentUser = data;
    },
  },
  actions,
  namespaced: true,
};

export default usersModule;
